export enum MessageTypeEnum {
  Email = 'Email',
  Notification = 'Notification'
}

export const MESSAGE_TYPE_ENUM_RECORD: Record<MessageTypeEnum, string> = {
  [MessageTypeEnum.Email]: 'Email',
  [MessageTypeEnum.Notification]: 'Notification'
};
